<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="8">
        <v-autocomplete
          v-model="entry.operationTypeId"
          v-bind="getObject('operationTypeId')"
          label="Tipo de Operação"
          :items="extraData.accountGlobalSharedContext.allOperationTypes"
          item-value="id"
          item-text="name"
          :disabled="readOnly || (isEdit && (entry.operationTypeId == 1 || entry.operationTypeId == 6))"
          @input="selectOperationType(true)"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.operationDate"
          v-bind="getObject('operationDate')"
          label="Data da Operação"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-alert type="info" v-if="entry.operationTypeId == 1">
        Planejamentos de colheita só podem ser realizadas em um único ciclo, permitindo o cálculo de produtividade individual do ciclo.
      </v-alert>

      <v-alert type="warning" v-if="entry.periodIdsAttribute.length > 1">
        IMPORTANTE: Planejamentos em múltiplos ciclos terão os itens consumidos e as atividades rateadas de acordo com o tamanho de cada um dos ciclos.
      </v-alert>

      <v-col cols="12" class="" v-if="periodsList.length > 0">
        <MultiSelect
          v-model="entry.periodIdsAttribute"
          v-bind="getObject('periodIdsAttribute')"
          label="Ciclo(s)"
          :items="periodsList"
          :loadingItems="periodsListLoading"
          itemSubText="additionalInfo"
          itemSecondSubText="secondAdditionalInfo"
          :maxLimit="entry.operationTypeId == 1 ? 1 : null"
          :readOnly="readOnly"
        >
          <template v-slot:new_action> 
            <PeriodNew
              :inlineAddButton="true"
              @entry-created="periodCreated"
              modelNameSingular="Ciclo"
            />
          </template>
        </MultiSelect>
      </v-col>

      <v-col cols="12" class="">
        <ActivitiesIndex
          :activities="entry.activitiesAttributes"
          :readOnly="readOnly"
          :initialDate="entry.operationDate"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.periodIdsAttribute.length > 0 && entry.operationType && (entry.operationType.kind == 'planting' || entry.operationType.kind =='fertilization' || entry.operationType.kind =='application' || entry.operationType.kind == 'forage_planting')">
        <PlanningConsumedItemsIndex
          :planningItems="entry.dummyExitMovementItemsAttributes"
          :planningOperation="entry"
          :readOnly="readOnly"
          :planningItemsTotalPrice.sync="planningItemsTotalPrice"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.periodIdsAttribute.length > 0 && entry.operationType && entry.operationType.kind == 'crop'">
        <PlanningProducedProductsIndex
          :producedProducts="entry.dummyEntryMovementItemsAttributes"
          :planningOperation="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observações"
          outlined
          :disabled="readOnly"
        ></v-textarea>
      </v-col>

    </v-row>

  </v-form>
</template>

<script>

import DateField from "@shared_components/date_field.vue";
import ActivitiesIndex from "@models/activities/index.vue";
import PlanningConsumedItemsIndex from "@models/operations/planning_operations/planning_consumed_items/index.vue";
import PlanningProducedProductsIndex from "@models/operations/planning_operations/planning_produced_products/index.vue";
import gql from 'graphql-tag';
import MultiSelect from "@shared_components/multi_select.vue";
import PeriodNew from "@models/periods/new.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      addressError: false,
      periodsList: [],
      periodsListLoading: false,
      planningItemsTotalPrice: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    ActivitiesIndex: ActivitiesIndex,
    DateField: DateField,
    // ConsumedItemsIndex: ConsumedItemsIndex,
    PlanningConsumedItemsIndex: PlanningConsumedItemsIndex,
    PlanningProducedProductsIndex: PlanningProducedProductsIndex,
    MultiSelect: MultiSelect,
    PeriodNew: PeriodNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    this.selectOperationType(false, true);
  },
  mounted() {
  },
  watch: {
    "entry.periodIdsAttribute": function() {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      this.selectPeriod();
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectOperationType: function(cleanPeriod=false, verifyPeriodsOnLoad=false) {
      if (this.entry.operationTypeId) {
        this.entry.operationType = this.extraData.accountGlobalSharedContext.allOperationTypes.find(obj => obj.id == this.entry.operationTypeId);
      
        this.periodsListLoading = true;
        this.$apollo
          .query({
            query: LOAD_ALL_PERIODS_FOR_PLANNING_OPERATION_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              operationTypeId: this.entry.operationTypeId
            }
          })
          .then(response => {
            // console.log("response dos all periods", response)
            this.periodsList = response.data.groundContext.allPeriodsEnabledForPlanningOperation;

            if (cleanPeriod) {
              this.entry.periodIdsAttribute = [];
            }

            if (verifyPeriodsOnLoad) {
              this.periodsList
              if (this.entry.periods && this.entry.periods.length > 0) {
                for(let period in this.entry.periods) {
                  if (!this.periodsList.some(periodList => periodList.id == this.entry.periods[period].id)) {
                    this.periodsList.push(this.entry.periods[period]);
                    // console.log("period adicionado ", this.entry.periods[period]);
                  }
                }
              }
            }

            if (this.entry.periodIdsAttribute.length == 0 && this.periodsList.length == 1) {
              this.entry.periodIdsAttribute = [this.periodsList[0].id];
            }
            // this.selectPeriod();
          })
          .catch(response => console.log(response))
          .finally(() => (this.periodsListLoading = false));
      }
      
    },
    selectPeriod: function() {
      this.entry.periods = [];
      for(let index in this.entry.periodIdsAttribute) {
        this.entry.periods.push(this.periodsList.find(obj => obj.id == this.entry.periodIdsAttribute[index]));
      }
      
    },
    periodCreated: function(period) {
      this.periodsList.unshift(period);
      this.entry.periodIdsAttribute.push(period.id);
    }
  }
};

const LOAD_ALL_PERIODS_FOR_PLANNING_OPERATION_QUERY = gql`
query ($operationTypeId: ID!) {
	groundContext {
    allPeriodsEnabledForPlanningOperation(operationTypeId: $operationTypeId) {
      id
      name
      area
      additionalInfo
      secondAdditionalInfo
    }
  }
}`;

</script>

<style scoped></style>
